import { type Environment as DatadogEnvironment } from '@storebrand-digital/common-datadog/dist/environment';

type SentryEnvironment = 'DEVELOP' | 'CLIENT-T' | 'PROD';

const sentryEnvironmentMap: Record<DatadogEnvironment, SentryEnvironment> = {
  development: 'DEVELOP',
  'client-t': 'CLIENT-T',
  test: 'CLIENT-T',
  production: 'PROD',
};

function isValidDatadogEnvironment(env: string): env is DatadogEnvironment {
  return ['development', 'client-t', 'production'].includes(env);
}

export function getDatadogEnvironment(env: string): DatadogEnvironment {
  if (isValidDatadogEnvironment(env)) {
    return env;
  }
  return 'production';
}

export function getSentryEnvironment(env: string): SentryEnvironment {
  if (isValidDatadogEnvironment(env)) {
    return sentryEnvironmentMap[env];
  }
  return 'PROD';
}
